import { apiClient } from "./client";

export interface RdnPrice {
  ts: string;
  price_uah_per_mwh: number | string;
}

export interface ImbalancePrice {
  ts: string;
  price_uah_per_mwh: number | string;
}

export const pricesApi = {
  rdn: (date: string) =>
    apiClient.get<RdnPrice[]>("/rdn-prices", { params: { date } }).then((r) => r.data),

  imbalance: (date: string) =>
    apiClient
      .get<ImbalancePrice[]>("/imbalance-prices", { params: { date } })
      .then((r) => r.data),
};
